import { OrderFormat as s } from "@ancon/wildcat-types";
import a from "./isWalletTopUpCheckoutItem.mjs";
function l(t) {
  if (t) {
    const { orderFormat: e, items: o } = t, r = e === s.System, m = o.some(a);
    return r && m;
  }
  return !1;
}
export {
  l as default
};
